<template>
    <div class="text-wraper" :class="customClass">
        <label
            class="text-label"
            :class="{
                error: !isFirstSave && isShowErrorLbl && !errorInfo.isValid,
            }"
            :for="id"
            >{{ label }}</label
        >
        <div class="input-box">
            <input
                type="text"
                v-if="disabled"
                v-model="content"
                style="color: #6e5541 !important; pointer-events: none"
                class="input-field"
                :id="id"
            />
            <input
                type="text"
                v-else
                v-model="content"
                class="input-field"
                :class="{
                    error: !isFirstSave && isShowErrorLbl && !errorInfo.isValid,
                }"
                :id="id"
                :maxlength="maxLength"
                :readonly="readOnly"
                @input="onChange()"
            />
            <div class="dash"></div>
            <!-- <span class="placeholder"
                  :class="{'error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
                  v-show="!content">
                  <span style="color: red;">*</span>ชื่อ</span> -->
        </div>
        <div
            class="error-text"
            v-if="isShowErrorLbl && !isAddress"
            v-show="!isFirstSave && !errorInfo.isValid"
        >
            {{ errorInfo.msg }}
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
/**
 * Property
 * @property {string} inputId (required) Field id for emit.
 * @property {object} inputLbl (required) Text for component.
 * @property {number} inputMinLength (optional) Minimum length.
 * @property {number} inputMaxLength (optional) Maximum Length.
 * @property {boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {object} errorInfo (optional) Validate result. example : { isValid: true, msg: '',}
 * @property {boolean} isTextOnly (optional) Only text.
 * @property {boolean} blockAutoComplete (optional) Block borwser auto complete field.
 * @property {string} addClass (optional) Add css class
 * Event
 * @event onChange Filter and validate.
 * Method
 * @method validateInput Validate text.
 */
export default {
    name: "TextInput",
    props: {
        //v-model
        value: String,
        //props
        inputId: String,
        inputLbl: Object,
        inputMinLength: Number,
        inputMaxLength: Number,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object,
        isTextOnly: Boolean,
        blockAutoComplete: Boolean,
        addClass: String,
        isAddress: Boolean,
        disabled: Boolean,
    },
    data: function () {
        return {
            id: "",
            label: "",
            placeholder: "",
            content: this.value,
            minLength: 0,
            maxLength: 0,
            readOnly: true,
            customClass: "",
        };
    },
    mounted: function () {
        this.id = this.inputId;
        this.label = this.inputLbl.name;
        this.placeholder = this.inputLbl.placeholder;
        this.minLength = this.inputMinLength || null;
        this.maxLength = this.inputMaxLength || null;
        this.customClass = this.addClass || "";
        this.validateInput();

        this.readOnly = this.blockAutoComplete;
        setTimeout(() => {
            this.readOnly = false;
        }, 500);
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = "";
            //Required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
            //Too short
            if (
                this.inputLbl.too_short &&
                this.minLength &&
                this.content.length < this.minLength
            ) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = Util.stringFormat(
                    this.inputLbl.too_short,
                    this.minLength
                );
                return;
            }
            //InValid format
            if (this.inputLbl.invalid) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.invalid;
                return;
            }
        },
        onChange: function () {
            var result = this.content;
            //Remove restrict character.
            if (!this.isAddress) {
                result = result.replace(Vue.RegExp.number, "");
                result = result.replace(Vue.RegExp.symbol, "");
            }
            result = result.replace(Vue.RegExp.emoji, "");
            // if(this.isTextOnly) {
            //     result = result.replace(Vue.RegExp.number, '');
            //     result = result.replace(Vue.RegExp.emoji, '');
            //     result = result.replace(Vue.RegExp.symbol, '');
            // }

            this.content = result;
            this.validateInput();
            this.$emit("input", result);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/_mixin.scss";
.text-wraper {
    color: $color-text-light !important;
    .input-box {
        color: $color-text-light !important;
        input {
            color: $color-text-light !important;
            width: 100%;
            background-color: transparent;
            border: none;
        }
        .dash {
            height: 2px;
            width: 100%;
            background-image: linear-gradient(
                to right,
                #6f5948 0%,
                #6f5948 50%,
                transparent 50%
            );
            background-size: 20px 2px;
            background-repeat: repeat-x;
        }
    }
    .error-text {
    }
}
</style>
